// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__XZYD0","approved":"Status_approved__1zcon","rejected":"Status_rejected__12Q6j","expired":"Status_expired__2IIk_","label":"Status_label__3uvYW"};